"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFillerColumn = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../..");
function createFillerColumn() {
    const column = new adaptivecards_1.Column("stretch");
    column.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, { text: "" }));
    return column;
}
exports.createFillerColumn = createFillerColumn;
//# sourceMappingURL=acUtils.js.map